import { render, staticRenderFns } from "./AllocationRules.vue?vue&type=template&id=b3f07586"
import script from "./AllocationRules.vue?vue&type=script&lang=js"
export * from "./AllocationRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports